import React from 'react';
import styled from 'styled-components';

export default function FeedTab({currTab, onChangeTab}) {
    return (
        <FeedTabsection>
            {currTab === 'company' ? (
                <>
                    <ActivatedTab>기업 인증</ActivatedTab>
                    <DisabledTab data-tab={'normal'} onClick={onChangeTab}>실시간 인증</DisabledTab>
                </>
            ) : 
            (
                <>
                    <DisabledTab data-tab={'company'} onClick={onChangeTab}>기업 인증</DisabledTab>
                    <ActivatedTab>실시간 인증</ActivatedTab>
                </>
            )
            }
            
           
        </FeedTabsection>
    );
}

const FeedTabsection = styled.div`
    min-width: 100%;
`;

const DisabledTab = styled.div`
    display: inline-block;
    font-size: normal;
    padding: 0 calc(100vw * (14 / 375))  calc(100vw * (14 / 375));
`;

const ActivatedTab = styled.div`
    display: inline-block;
    padding: 0 calc(100vw * (14 / 375))  calc(100vw * (14 / 375)) calc(100vw * (14 / 375));
    font-weight: 700;
    border-bottom: calc(100vh * (3 / 812)) solid;
`;